import { useCallback, useEffect, useRef, useState } from 'react';

export default function useKonvaImage(url) {
  const containerRef = useRef(null);
  const [image, setImage] = useState(null);
  const [naturalSize, setNaturalSize] = useState({ w: 1, h: 1 });
  const [display, setDisplay] = useState({ w: 0, h: 0 });

  useEffect(() => {
    if (!url) return;
    setImage(null);
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      setImage(img);
      setNaturalSize({ w: img.naturalWidth, h: img.naturalHeight });
    };
    img.src = url;
    return () => { img.onload = null; };
  }, [url]);

  const computeDisplay = useCallback(() => {
    if (!containerRef.current || !naturalSize.w) return;
    const w = containerRef.current.offsetWidth;
    setDisplay({ w, h: Math.round(naturalSize.h * (w / naturalSize.w)) });
  }, [naturalSize]);

  useEffect(() => {
    computeDisplay();
    const el = containerRef.current;
    if (!el) return;
    const observer = new ResizeObserver(computeDisplay);
    observer.observe(el);
    return () => observer.disconnect();
  }, [computeDisplay]);

  return { containerRef, image, display };
}
